import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useAccountModel } from "@/views/account/customerManage/view/detail/account/accountModel";
import { useDetailModel } from "../detailModel";
import { useRechargeModel } from "./rechargeModel";
import { rechargeStatus } from "@/types/FmsDs";


export const RechargeSearchBox = () => {
    const { customerUserDs } = useAccountModel();
    const { orgDs, beDs } = useDetailModel(model => [model.orgDs, model.beDs]);

    const {
        onSearch,
        searchParam,
        onReset,
        updateSearchParam,
        loadData
    } = useRechargeModel()


    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户",
            fieldName: "accountCode",
            size: "small",
            options: customerUserDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "实体",
            fieldName: "beCode",
            size: "small",
            disabled: false,
            options: beDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            format: "YYYY-MM-DD",
            size: "small",
            ...searchProp,
            onChange: (data) => {
                let newData = {
                    rechargeTimeRange: data.time[0] !== '' && data.time[1] !== '' ? {
                        startTime: data.time[0] + ' 00:00:00',
                        endTime: data.time[1] + ' 23:59:59'
                    } : undefined,
                    ...data
                }
                updateSearchParam(newData)
            }
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchBtn",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "resetBtn",
            onClick: onReset
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "备注",
            fieldName: "note",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "审核状态",
            fieldName: "statusList",
            size: "small",
            disabled: false,
            options: rechargeStatus,
            ...searchProp
        },
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
